let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5nmY1")).then(() => parcelRequire('cR50m'));